import { Component, Element, Fragment, h, Prop } from "@stencil/core"
import { getAppearance } from "../../core/helpers/webcomponent-helpers"

@Component({
  tag: "sdx-stock-counter",
  styleUrl: "stock-counter.scss",
  shadow: true,
})
export class StockCounter {
  @Element() public el!: HTMLSdxStockCounterElement

  /**
   * Amount, corresponds to the length of the coloured bar.
   */
  @Prop() public amount: number = 0

  /**
   * Total, corresponds to the full bar length.
   */
  @Prop() public total: number = 0

  /**
   * The colour variation.
   */
  @Prop() public theme: HTMLSdxTagElement["theme"] = "standard"

  private getComponentClassNames() {
    return {
      component: true,
      [this.theme]: true,
      [getAppearance(this.el)]: true,
    }
  }

  private getStyle() {
    if (this.amount < 0 || this.total < this.amount) {
      return
    }

    return {
      width: `${(this.amount / this.total) * 100}%`,
    }
  }

  public render() {
    const lang = this.el.lang || document.documentElement.lang || "en"
    return (
      <div class={this.getComponentClassNames()}>
        <div class="bar-total"></div>
        <div class="bar-amount" style={this.getStyle()}></div>
        <div class="label">
          {lang === "de" && (
            <Fragment>
              <b>noch {this.amount}</b> von {this.total} Stück
            </Fragment>
          )}
          {lang === "fr" && (
            <Fragment>
              <b>plus que {this.amount}</b> pièces sur {this.total}
            </Fragment>
          )}
          {lang === "it" && (
            <Fragment>
              <b>ancora {this.amount}</b> pezzi su {this.total}
            </Fragment>
          )}
          {lang === "en" && (
            <Fragment>
              <b>{this.amount}</b> of {this.total} remaining
            </Fragment>
          )}
        </div>
      </div>
    )
  }
}
